import { Messages } from '../../../../codegen/Localize';
import { editFlow } from '../../../../flow/actions/EditFlowReduxAction';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IWebEditFlowAction } from '../../../../ts/ServerApi/types/actionNames';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { selectEditingFlowsEnabled } from '../../../../flow/selectors/FlowSelectors';
import { AppState } from '../../../state/AppState';
import { getAppStore } from '../../../AppStore';

export const EditFlowEntityAction: IEntityAction<IContentInfo<'flow'>, IWebEditFlowAction> = {
  name: EntityActionNames.EditFlow,
  translateName: Messages.editFlow,
  isVisible: (_, state: AppState) => state ? selectEditingFlowsEnabled(state) : selectEditingFlowsEnabled(getAppStore().getState()),
  isClickable: (availableActions: IWebEditFlowAction) => !!availableActions && availableActions.webEditFlow,
  createReduxAction: (targetItems: IContentInfo[]) => editFlow(targetItems[0])
};
